<template>
  <g fill-rule="evenodd">
    <path
      d="M17.6 0H4.8a3.2 3.2 0 00-3.2 3.2V4H.8a.8.8 0 000 1.6h.8v3.2H.8a.8.8 0 000 1.6h.8v3.2H.8a.8.8 0 100 1.6h.8v.8a3.2 3.2 0 003.2 3.2h12.8c.88 0 1.6-.72 1.6-1.6v-16c0-.88-.72-1.6-1.6-1.6z"
    />
    <path
      d="M17.6 17.6H4.8A1.6 1.6 0 013.2 16v-.8H4a.8.8 0 000-1.6h-.8v-3.2H4a.8.8 0 000-1.6h-.8V5.6H4A.8.8 0 004 4h-.8v-.8c0-.88.72-1.6 1.6-1.6h12.8v16z"
      class="secondary-color"
    />
    <path
      d="M9.6 7.2a1.6 1.6 0 113.2 0 1.6 1.6 0 01-3.2 0m-2.4 8a.8.8 0 00.8-.8v-.8a3.2 3.2 0 016.4 0v.8a.8.8 0 001.6 0v-.8a4.8 4.8 0 00-2.49-4.2 3.2 3.2 0 10-4.62 0 4.8 4.8 0 00-2.49 4.2v.8c0 .44.36.8.8.8"
    />
  </g>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "TestersIcon",
});
</script>
